<template>
  <div>
    <v-row
      class="ml-2 pl-12 mb-0 pb-0 mr-4"
      v-if="
        item.description !== null &&
        item.description !== '' &&
        item.description !== '\n\n\n'
      "
    >
      <v-col>
        <v-row class="text-justify grey--text text--darken-2">
          {{ descriptionText(item.description) }}
        </v-row>
      </v-col>
    </v-row>

    <!-- ITEMS -->

    <span v-if="item.boat_items" class="body-2 ml-2 pl-12 black--text">{{
      $t("components.boatItems.boatItemListDetails.items")
    }}</span>
    <v-list-item class="ml-2 pl-12 mb-0 pb-0 mt-0 pt-0" v-if="item.boat_items">
      <v-row fluid>
        <v-col
          class="mt-0 pt-0 pb-0 mb-0"
          v-for="(boatItem, itemIndex) in item.boat_items"
          :key="itemIndex"
          no-gutters
          :cols="item.boat_items.length === 1 ? 8 : 5"
        >
          <v-card flat>
            <v-text-field
              class="mt-2 pt-1"
              v-model="boatItem.serial_number"
              :label="
                $t('components.boatItems.boatItemListDetails.itemSerialNumber')
              "
              type="text"
              color="primary"
              :disabled="
                readonly || (!boatItem.is_editable && !boatItem.is_readable)
              "
              @input="updateItem(item, itemIndex, $event)"
            >
              <template v-slot:append v-if="!readonly">
                <v-icon
                  :disabled="
                    disableDeleting ||
                    (!boatItem.is_removable && !boatItem.is_editable)
                  "
                  @click="deleteItem(item, itemIndex, itemIndex)"
                  color="red"
                  >mdi-delete</v-icon
                >

                <licence-tooltip
                  :feature="disableAddingBoatItemsBasedOnItemsCrmGroupLicence"
                  :disabled="
                    disableAddingBoatItemsBasedOnItemsCrmGroupLicence.disabled
                  "
                  :enabled="
                    disableAddingBoatItemsBasedOnItemsCrmGroupLicence.enabled
                  "
                  float-direction="right"
                >
                  <template v-slot:action="{ attrs, disabled, enabled }">
                    <v-icon
                      v-if="itemIndex === item.boat_items.length - 1"
                      v-bind="attrs"
                      :disabled="disabled"
                      @click="addItem(item)"
                      color="primary"
                      style="cursor: pointer"
                      >mdi-plus-circle</v-icon
                    >
                  </template>
                </licence-tooltip>
              </template>
            </v-text-field>
          </v-card>
        </v-col>
      </v-row>
    </v-list-item>

    <!-- DOCUMENTS -->
    <span v-if="item.boat_items" class="body-2 ml-2 pl-12 black--text">{{
      $t("components.boatItems.boatItemListDetails.documents")
    }}</span>
    <v-list-item
      class="ml-0 pl-9 mb-0 pb-0 mt-0 pt-0"
      v-if="item.documents.length !== 0"
    >
      <v-row fluid>
        <v-col class="mt-0 pt-0 pb-0 mb-0">
          <v-btn
            v-for="(document, index) in item.documents"
            :key="index"
            class="text-none"
            text
            color="grey darken-2"
            @click="openDocument(document)"
            ><v-icon class="mr-2">mdi-file-document</v-icon>
            {{ document.title }}
          </v-btn>
        </v-col>
      </v-row>
    </v-list-item>

    <v-list-item class="pl-3 ml-8">
      <v-row>
        <v-btn
          class="float-right"
          text
          color="primary"
          prepend-icon="mdi-plus-circle"
          @click="itemDetails(item)"
        >
          <span>
            <v-icon medium class="mx-1">mdi-information</v-icon>
            {{ $t("components.boatItems.boatItemListDetails.details") }}
          </span>
        </v-btn>
      </v-row>
    </v-list-item>
  </div>
</template>

<script>
import api from "@/utils/api";
import { mapGetters } from "vuex";
import snackbar from "@/utils/snackbar";
import LicenceTooltip from "@/components/general/LicenceTooltip";

export default {
  components: {
    LicenceTooltip,
  },
  props: {
    item: {
      type: Object,
      default: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disableAdding: {
      type: Boolean,
      default: false,
    },
    disableDeleting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters([
      "getIframeStatus",
      "disableAddingPartsWithoutAdvancedLicenceHandler",
    ]),

    disableAddingBoatItemsBasedOnItemsCrmGroupLicence() {
      return this.disableAddingPartsWithoutAdvancedLicenceHandler(
        "add-part-on-boat"
      )(this.item.crm_group)(this.item, "details");
    },
  },
  created() {},

  methods: {
    descriptionText(text) {
      let array = text.split(" ").splice(0, 20);
      if (array.length === 20) {
        array[array.length - 1] = array[array.length - 1] + "...";
      }
      return array.join(" ");
    },
    openDocument(document) {
      !this.getIframeStatus
        ? window.open(document.file_resource.file, "_blank")
        : window.open(document.file_resource.file, "_self");
    },

    itemDetails(item) {
      api
        .getItem(item.uuid, {}, false)
        .then((resp) => {
          const routeData = this.$router.resolve({
            name: "itemsDetails",
            params: { id: item.uuid },
          });

          !this.getIframeStatus
            ? window.open(routeData.href, "_blank")
            : this.$router.push({
                name: "itemsDetails",
                params: { id: item.uuid },
              });
        })
        .catch((err) => {
          if (err.response.status === 403 || err.response.status === 404) {
            snackbar.error(
              this.$t("utils.snackbar.error.insufficientRights"),
              false
            );
          }
        });
    },

    findIndexOfItem(array, boatItem) {
      return array.findIndex((item) => item.uuid === boatItem.uuid);
    },

    deleteItem(boatItem, index, clusterItemIndex) {
      this.$emit("delete", boatItem, index);
    },

    updateItem(boatItem, index, event) {
      this.$emit("update", boatItem, index, event);
    },

    addItem(clusterItem) {
      this.$emit("add", clusterItem);
    },
  },
};
</script>

<style scoped>
.boat-items-list--size {
  max-height: 800px;
  overflow-y: auto;
}
.overflow-y--enabled {
  overflow-y: scroll;
}
.overflow-y--disabled {
  overflow-y: hidden;
}
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
